module.exports = __webpack_public_path__ + "img/user-avatar.1a4644b2.png";